<template>
  <div class="dd-page">
    <header class="dd-header">
      <strong>Docker配信システム</strong
      ><button @click="logout">ログアウト</button>
    </header>
    <main class="dd-main">
      <div class="dd-title">
        <div>
          <h1>Installer管理</h1>
          <p>公開操作は登録情報の保存と分けて行います。</p>
        </div>
        <button class="secondary" @click="$router.push('/menu')">
          メニューへ戻る
        </button>
      </div>
      <p v-if="error" role="alert" class="dd-message error">{{ error }}</p>
      <p v-if="message" role="status" class="dd-message">{{ message }}</p>
      <section class="dd-panel">
        <div class="dd-toolbar">
          <select v-model="filter" aria-label="公開状態">
            <option value="">すべての公開状態</option>
            <option v-for="(label, key) in statuses" :key="key" :value="key">
              {{ label }}
            </option></select
          ><button class="secondary" :disabled="busy" @click="load">
            再読み込み</button
          ><button class="secondary" @click="$router.push('/users')">
            取得許可の設定
          </button>
        </div>
        <div class="dd-table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID / Version</th>
                <th>配布対象</th>
                <th>公開状態</th>
                <th>ファイル</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in filtered" :key="row.docker_id">
                <td>
                  {{ row.docker_version
                  }}<small
                    >ID {{ row.docker_id }} / {{ row.release_date }}</small
                  ><small>{{ row.docker_info }}</small>
                </td>
                <td>
                  {{ row.configuration }} / {{ row.install_kind
                  }}<small>{{ row.target_os }} / {{ row.target_arch }}</small>
                  <small
                    >{{ row.change_type || '—' }}
                    {{ row.change_type_label }}</small
                  >
                </td>
                <td>
                  <span :class="['dd-badge', row.publication_status]">{{
                    statuses[row.publication_status]
                  }}</span>
                </td>
                <td>
                  {{ row.file_name
                  }}<small
                    >{{ row.file_size }} bytes /
                    {{
                      row.file_exists ? '存在確認済み' : 'ファイル要確認'
                    }}</small
                  >
                </td>
                <td>
                  <div class="dd-toolbar" style="margin: 0">
                    <button
                      class="secondary"
                      :disabled="busy"
                      @click="edit(row)"
                    >
                      {{ row.content_frozen ? '詳細' : '編集' }}</button
                    ><button
                      :disabled="busy || row.publication_status === 'testing'"
                      @click="publish(row, 'testing')"
                    >
                      テスト公開</button
                    ><button
                      :disabled="busy || row.publication_status === 'released'"
                      @click="publish(row, 'released')"
                    >
                      正式公開</button
                    ><button
                      class="danger"
                      :disabled="busy || row.publication_status === 'stopped'"
                      @click="publish(row, 'stopped')"
                    >
                      停止</button
                    ><button
                      v-if="
                        !row.content_frozen &&
                        row.publication_status === 'draft'
                      "
                      class="danger"
                      :disabled="busy"
                      @click="remove(row)"
                    >
                      削除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="!filtered.length">
                <td colspan="5" class="dd-empty">登録データがありません</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section v-if="selected" ref="editor" class="dd-panel">
        <h2>版の詳細・登録情報</h2>
        <p class="dd-note">
          SHA-256: <code>{{ selected.sha256 || '未登録' }}</code>
        </p>
        <p v-if="selected.content_frozen" class="dd-note">
          公開履歴のある版は固定されています。修正版は別登録してください。
        </p>
        <form @submit.prevent="save">
          <fieldset
            :disabled="busy || selected.content_frozen"
            style="border: 0; margin: 20px 0 0; padding: 0"
          >
            <InstallerFields :form="selected" />
            <div v-if="!selected.content_frozen" class="dd-actions">
              <button type="submit">登録情報を保存</button>
            </div>
          </fieldset>
        </form>
        <div v-if="!selected.content_frozen" class="dd-section">
          <label
            >RELEASE_NOTES.md取込<input
              type="file"
              accept=".md"
              :disabled="busy"
              @change="importNotes"
          /></label>
          <p class="dd-note">
            保存済みのVersion・Buildへ紐付けます。編集中の登録情報は先に保存してください。
          </p>
        </div>
        <div class="dd-actions">
          <button class="secondary" @click="download">管理用ファイル取得</button
          ><button class="secondary" @click="selected = null">閉じる</button>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import api from '../api';
import { statuses } from '../fields';
import InstallerFields from '../components/InstallerFields';
export default {
  name: 'DockerManageView',
  components: { InstallerFields },
  data() {
    return {
      rows: [],
      filter: '',
      statuses,
      selected: null,
      error: '',
      message: '',
      busy: false,
    };
  },
  computed: {
    filtered() {
      return this.rows.filter(
        (r) => !this.filter || r.publication_status === this.filter
      );
    },
  },
  created() {
    this.load();
  },
  methods: {
    async importNotes(e) {
      const file = e.target.files[0];
      if (!file || !this.selected) return;
      const row = this.rows.find(
        (r) => r.docker_id === this.selected.docker_id
      );
      if (
        JSON.stringify({ ...row, module_ids: row.module_ids.join(',') }) !==
        JSON.stringify(this.selected)
      ) {
        this.error = '編集中の登録情報を先に保存してください';
        e.target.value = '';
        return;
      }
      this.busy = true;
      this.error = '';
      try {
        const data = new FormData();
        data.append('revision', String(row.revision));
        data.append(
          'release',
          `${row.product_version}_${row.build_date}_${row.build_no}`
        );
        data.append('file', file);
        await api.post(`/api/docker/${row.docker_id}/release-notes`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        await this.load();
        this.edit(this.rows.find((r) => r.docker_id === row.docker_id));
        this.message = 'リリースノートを対象版へ取り込みました';
      } catch (err) {
        this.error = err.response?.data?.error || '取込に失敗しました';
      } finally {
        this.busy = false;
        e.target.value = '';
      }
    },
    async load() {
      this.busy = true;
      try {
        this.rows = (await api.get('/api/docker')).data;
      } catch (e) {
        this.error = e.response?.data?.error || '読み込みに失敗しました';
      } finally {
        this.busy = false;
      }
    },
    edit(row) {
      this.selected = { ...row, module_ids: row.module_ids.join(',') };
      this.$nextTick(() =>
        this.$refs.editor?.scrollIntoView({ behavior: 'smooth' })
      );
    },
    async save() {
      if (this.busy) return;
      this.busy = true;
      this.error = '';
      try {
        await api.put('/api/docker/' + this.selected.docker_id, this.selected);
        this.message = '登録情報を保存しました';
        this.selected = null;
        await this.load();
      } catch (e) {
        this.error = e.response?.data?.error || '保存に失敗しました';
      } finally {
        this.busy = false;
      }
    },
    async publish(row, state) {
      const warning =
        state === 'released' ? '取得条件に合う正式ユーザへ公開されます。' : '';
      if (
        !confirm(
          `${row.docker_version}\n${row.file_name}\n${
            statuses[row.publication_status]
          } → ${statuses[state]}\n${warning}\n変更しますか？`
        )
      )
        return;
      this.busy = true;
      this.error = '';
      try {
        await api.post(`/api/docker/${row.docker_id}/publication`, {
          publication_status: state,
          revision: row.revision,
        });
        this.message = '公開状態を変更しました';
        this.selected = null;
        await this.load();
      } catch (e) {
        this.error = e.response?.data?.error || '公開状態の変更に失敗しました';
      } finally {
        this.busy = false;
      }
    },
    async remove(row) {
      if (
        !confirm(`${row.docker_version} の未公開登録とファイルを削除しますか？`)
      )
        return;
      this.error = '';
      try {
        await api.delete('/api/docker/' + row.docker_id);
        this.selected = null;
        this.message = '削除しました';
        await this.load();
      } catch (e) {
        this.error = e.response?.data?.error || '削除に失敗しました';
      }
    },
    download() {
      const a = document.createElement('a');
      a.href =
        (api.defaults.baseURL || '') +
        '/api/admin/installers/' +
        this.selected.docker_id +
        '/download';
      a.click();
    },
    async logout() {
      await api.post('/api/admin/logout');
      this.$router.push('/login');
    },
  },
};
</script>
